import { createCustomAction } from 'typesafe-actions';

export const toggleSidebarCollapsed = createCustomAction('SIDEBAR_COLLAPSED_TOGGLED', type => () => ({
  type,
}));
